import { baseProfileApi } from "./redux";

export const ProfileCoreMiddlewares = [
  baseProfileApi.middleware,
];

export const ProfileCoreReducers = {
  [baseProfileApi.reducerPath]: baseProfileApi.reducer,
};